import { render } from "./LambdaService.vue?vue&type=template&id=4e1af55a"
import script from "./LambdaService.vue?vue&type=script&lang=js"
export * from "./LambdaService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__